import { createContext, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tooltip,
  Typography,
} from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import {
  initialSearchData,
  ApprovedSearchContextType,
  PriorSearchParamsType,
  SearchResponseType,
} from "./types";
import PriorApprovalTabs from "./components/PriorApprovalTabs";
import moment from "moment";
import { CustomFormField } from "@utilifiles/component/CustomFormElement";
import { useForm } from "react-hook-form";
// type ParamsType = Omit<ProirApprovalSearchFilterType, "clinicId">;

export const ApprovedSearchContext = createContext<ApprovedSearchContextType>({
  priorApprovalSearchParams: initialSearchData,
  searchResult: {
    items: [],
    totalCount: 0,
    responseMessage: ""
  },
  setPriorApprovalSearchParams: () => { },
  setSearchResult: () => { },
  downloadLoading: false,
  setDowloadLoading: () => { },
});

function PriorApprovalDashboard() {
  const [downloadLoading, setDowloadLoading] = useState<boolean>(false);
  const [priorApprovalSearchParams, setPriorApprovalSearchParams] =
    useState<Omit<PriorSearchParamsType, "clinicId">>(initialSearchData);

  const [searchResult, setSearchResult] = useState<SearchResponseType>({
    items: [],
    totalCount: 0,
    responseMessage: ""
  });

  const download = (date: string) => {
    setPriorApprovalSearchParams((prev) => ({
      ...prev,
      fromDate: date,
      toDate: date,
      operation: "download",
    }));

  };
  const [openDownloadModal, setOpenDownloadModal] = useState(false);
  const {
    handleSubmit: handleDownloadSubmit,
    control: downloadControl,
    reset: resetDownloadForm,
  } = useForm<{ fromDate: string }>({
    defaultValues: {
       fromDate: moment().format("YYYY-MM-DD"),
    },
  });
  return (
    <ApprovedSearchContext.Provider
      value={{
        priorApprovalSearchParams,
        setPriorApprovalSearchParams,
        searchResult,
        setSearchResult,
        downloadLoading,
        setDowloadLoading,
      }}
    >
      <div className="flex flex-col gap-3 flex-wrap p-3">
        <Box sx={{ width: "100%", typography: "body1" }}>
          <div className="pb-3 pt-3 flex justify-between">
            <Typography
              margin={0}
              color="primary"
              fontSize={14}
              fontWeight={"bold"}
            >
              Insurance - Prior Approval
            </Typography>
            <Tooltip title="Download prior approval">
              <Button
                onClick={() => setOpenDownloadModal(true)}
                color="success"
                disabled={downloadLoading}
                endIcon={(downloadLoading && (priorApprovalSearchParams.operation == "download")) ? <CircularProgress color="success" size={18} /> : <FileDownloadIcon />}
              >
                Prior Approval
              </Button>
            </Tooltip>
          </div>
          <PriorApprovalTabs />
        </Box>
        <Dialog
          open={openDownloadModal}
          onClose={() => {
            setOpenDownloadModal(false);
            resetDownloadForm();
          }}
          maxWidth="xs"
          fullWidth
          PaperProps={{
            sx: { borderRadius: 3 },
          }}
        >
          <DialogTitle sx={{ fontWeight: 600 }}>
            Download Prior Approval
          </DialogTitle>

          <form
            onSubmit={handleDownloadSubmit((data) => {
              download(data.fromDate);
              setOpenDownloadModal(false);
              resetDownloadForm();
            })}
          >
            <DialogContent sx={{ pt: 1 }}>
              <CustomFormField
                control={downloadControl}
                element="datepicker"
                name="fromDate"
                fieldProps={{
                  label: "Select Date",
                  inputProps: {
                    max: moment().format("YYYY-MM-DD"),
                  },
                }}
                rules={{ required: "Date required" }}
              />
            </DialogContent>

            <DialogActions sx={{ px: 3, pb: 2 }}>
              <Button
                onClick={() => {
                  setOpenDownloadModal(false);
                  resetDownloadForm();
                }}
                variant="outlined"
              >
                Cancel
              </Button>

              <Button
                type="submit"
                variant="contained"
                color="success"
              >
                Confirm
              </Button>
            </DialogActions>
          </form>
        </Dialog>
      </div>
    </ApprovedSearchContext.Provider>
  );
}

export default PriorApprovalDashboard;
